<!--
================================================
Layout Principal de l'application
(une fois le login effectué)

Vérifie également la concordance du slug dans l'url et celui dans le cookie d'authentification.

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="appLayoutComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
    <maintenance-comp></maintenance-comp>
    <modal-premium-limitation-comp></modal-premium-limitation-comp>
    <!--        <live-chat-comp></live-chat-comp>-->
    <env-identifier-comp></env-identifier-comp>
    <theme-manager-comp></theme-manager-comp>
    <auth-checker-comp></auth-checker-comp>

    <impersonation-warning-comp v-if="$auth.getImpInProgress()"></impersonation-warning-comp>

    <transition name="fade">

      <div key="1" v-if="appIsLoading"><!--l'attribut "key" est requis pour la transition-->
        <page-loader-comp></page-loader-comp>
      </div>


      <div key="2" v-else class="appLayoutContent"><!--l'attribut "key" est requis pour la transition-->

        <global-notification-comp></global-notification-comp>

        <app-navbar-comp></app-navbar-comp>
        <div class="columns">
          <div class="column AppMenu
                  is-one-fifth-fullhd
                  is-one-fifth-widescreen
                  is-one-fifth-desktop
                  is-one-fifth-tablet
                  is-12-mobile"
          >
            <app-menu-comp></app-menu-comp>
          </div>

          <div class="column columnAppContent">
            <slot name="AppContent" id="AppContent">
              AppContent default content
            </slot>

            <div class="foot" id="footer">
              <div class="appInfos">
                            <span class="appName">
                            Cronocloud  <span id="pwaVersion">{{ $t('versionNumero', {num: pwaVersion}) }}</span>
                            </span> |

                <span class=""><a target="_blank"  href="https://cronocloud-053.freshstatus.io/">{{$t('statuts')}}</a></span> |

                <span class=""><a target="_blank"  href="https://cronocloud.freshdesk.com">{{$t('centreDAide')}}</a></span> |
                <span class=""><a target="_blank"  v-bind:href="'https://cronocloud.com/'+$i18n.locale+'/updates'">{{$t('misesAjour')}}</a></span> |
                <theme-switch-comp></theme-switch-comp>

              </div>
            </div>

          </div>

        </div>
      </div>

    </transition>

  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
// @ is an alias to /src
import {mapState} from 'vuex'

    import AppNavbarComp from '@/components/AppNavbarComp.vue'
    import AppMenuComp from '@/components/AppMenuComp.vue'
    import GlobalNotificationComp from "./GlobalNotificationComp";
    import PageLoaderComp from "./PageLoaderComp";
    import ImpersonationWarningComp from "./ImpersonationWarningComp";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import LiveChatComp from "./LiveChatComp";
    import EnvIdentifierComp from "@/components/EnvIdentifierComp";
    import AuthCheckerComp from "@/components/AuthCheckerComp";
    import ThemeManagerComp from "@/components/ThemeManagerComp";
import ThemeSwitchComp from "@/components/ThemeSwitchComp";
import ModalPremiumLimitationComp from "@/components/ModalPremiumLimitationComp";
import MaintenanceComp from "@/components/MaintenanceComp";



    export default {
        name: 'AppLayoutComp',
        mixins: [SentryMixin, InitialHydrationMixin],
        data: function(){
            return{
                pwaVersion: process.env.VUE_APP_VERSION,
            }
        },
        computed: {
            // computed props for store :
            ...mapState({
                appIsLoading: state => state.app.isLoading,
              themeToDisplay: state => state.app.themeToDisplay
            }),
        },
        components: {
          MaintenanceComp,
          ModalPremiumLimitationComp,
          ThemeSwitchComp,
          AuthCheckerComp,
          ThemeManagerComp,

          EnvIdentifierComp,
            AppNavbarComp,
            AppMenuComp,
            GlobalNotificationComp,
            PageLoaderComp,
            LiveChatComp,
            ImpersonationWarningComp
        },
        methods: {

    /**
     Vérifie que le slug de l'organization dans l'url correspond bien à celui enregistré dans le cookie d'authentification.

     Cette méthode à pour but d'éviter que l'appli se base sur un mauvais slug dans le cas où un utilisateur modifierait l'url. Ainsi pour dans un contexte DX on peut se baser sur le slug dans l'url. (si les 2 slugs ne correspondent l'utilisateur sera redirigé vers la page notFound 404).
     **/
    checkOrganization: function () {
      if(this.$route.params.organization !== JSON.parse(this.$cookie.get('auth')).organization ){
        // redirection 404
        this.$router.replace('/notFound')
        // log sentry pour infos
        this.logToSentry(this, `🧪 organization in url does not match session cookie. url=${this.$route.params.organization} | cookie=${JSON.parse(this.$cookie.get('auth')).organization}`, 'info')

      }
    },

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
    this.checkOrganization()
    this.userInitialHydration(this)
    this.$root.$emit('layout_loaded', this.$options.name) // pour custom favicon @todo à vérifier ne semble pas fonctionner, je garde pour le moment car peut-être dû au cache.

  }
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

/*@import '../assets/css/bulmaCustom';*/
@import '../assets/css/globalVar';
@import "../assets/css/bulmaResponsiveDep.scss";

// ----------------------------------------------------
// STYLES GLOBAUX POUR LE APP LAYOUT
// Ces styles s'appliquent à des composant qui sont inclus l'intérieur du AppLayoutComp
// ----------------------------------------------------
body{
  @include mobile{
    overflow-x: hidden; // empêche le scroll horizontal sur mobile (https://stackoverflow.com/questions/49642824/bulma-columns-mobile-overflowing-body)
  }

  .noPrint{
    @media print {
      display: none;
    }
  }
  .printOnly{
    display: none;
    @media print {
      display: block;
    }
  }
}


#appLayoutComp {

  ////////////////////////////////////////////////////////////////////////////////////////
  // LIGHT UI ///////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////

  pre {background-color: darkslategray; color: white}
  .column{
    //border: dashed 1px hotpink;
  }
  // LAYOUT  ----------------------------------------------------
  .appTitle {

        h3{
            color:#666;
            font-weight: bold;
            font-size: 1rem;
            text-transform: uppercase;

        }
        .icon{
            margin-right: 0.4rem;
            padding-top: 0.4rem;
            color:#ccc;
        }

        .appSubTitle{
            margin-top: 0.3rem;
            text-transform: none;
            font-style: italic;
            font-size: 0.95rem;


        }

    }
    // BLOC  ----------------------------------------------------
        .appBloc{
          border: #eeefef 1px solid;
          padding: 0;
            background: #fff;
            /*margin: 0 2rem 0 0;*/
            @include mobile {
                margin: 0;
            }
        }
    // TYPOS  ----------------------------------------------------
        .appTitle {
            text-align: left;
            margin-bottom: 1.5rem;
            color: #a8a9a7;
            font-weight: bold;
            font-size: 0.95rem;
        }

    .isThird{
      color: $brandThird !important;
    }
  .isFourth{
    color: $brandFourth !important;
  }

  // DATEPICKER -----------------------------------------------
  .datepicker {
    color: $brandThird;
    padding: 1.4rem;
  }

  // MODALE ----------------------------------------------------

  .modal-background{
    backdrop-filter: blur(6px);
    background-color: rgba($brandThird,.7);
  }

  .modal-card-title{
    font-weight: bold;
  }
  @include touch{
    .modal-card{
      padding: 1rem;
    }
  }

  .modal-card-body{
    text-align: left;
  }

  .modal-card-foot{
    justify-content: flex-end !important; // va aligner le contenu (ex : les boutons) à droite https://github.com/jgthms/bulma/issues/516#issuecomment-294293647

    .cancelLink // pour le lien annuler
    {
      color: #c6c6c6 !important;
      text-decoration: none !important;
      font-weight: bold !important;
      font-size: 0.9rem !important;
      &:hover{
        //color: red !important; ;
        text-decoration: underline !important;
      }
      &:active{
        background: none !important;
        color: darken(#c6c6c6,3%) !important;
      }
    }

    .validBtn {
      font-size: 0.95rem;
      font-weight: bold !important;
      padding: 0.5rem 1rem;
    }
  }

  .modal {
    @include mobile {
      .modal-card-body {
        padding: 1rem; //@todo wip
      }
    }
  }

  // MODALE DELETE ITEM ----------------------------------------
  // Mutualise les styles de ModalDeleteProjectComp et ModaleDeleteClientComp
  .modalDeleteItem{
    .modal-card-head .icon{
      margin-right: 0.5rem;
      color: $brandFourth;
    }
    .field{
      margin-bottom: 1.5rem;
    }

    .label{
      margin-bottom:0;
    }
    .help{
      margin-top: 0
    ;}

    .warningTitle{
      text-transform: uppercase;
      font-weight: bold;
      color:$brandRed;
      font-size: 1.4rem;
      margin-bottom: 1rem;

      .icon {
        padding-top: 0.5rem;
        height: 1.8rem;
        animation: glow 0.5s infinite alternate;
        @keyframes glow {
          from {color: $brandRed;}
          to {color: #ffab2b;}
        }
      }
    }
    .warningText{
      color:#666;

    }

    //////////////////////////////////////
    // DARK UI ///////////////////////////
    &.darkMode {
      .warningText{
        color:$darkTxt

      }
    }

  }

  // TABLE ----------------------------------------------------

  .table {
    //$borderColor: #eeefef;
    $borderColor: #ddd;
    border-bottom: solid 1px $borderColor;

    thead {
      background: #f9f9f9;

      tr {
        border: solid $borderColor;
        border-width: 1px 1px 0 1px;
        padding: 0 2rem 0;

        .icon {
          color: #e2e6e7;
          $size: 0.9rem;
          width: $size;
          height: $size;
          margin-right: 0.2rem;
        }
      }

      th {
        font-weight: bold;
      }


    }

    tr {
      border: solid $borderColor;
      border-width: 0 1px;
      font-size: 0.9rem;
      @include mobile {
        font-size: 0.8rem;
      }
      td {
        vertical-align: middle; // aligne le contenu des td verticalement 🤘
        @include mobile {padding: .8rem 0.2rem;}  // réduction du padding des cellules sur mobile pour avoir les icones et le contenu sur une seul ligne
        @include tablet {padding: 1rem 0.5rem;}
        @include desktop {padding: 1rem 0.7rem;}
        @include widescreen {padding: 1rem 1.2rem;}
        @include fullhd {padding: 1rem 1.5rem;}
      }

      th {
        @include mobile {
          padding: 1rem
        }
      }
    }

    .menuLink{
      padding: 0 0.5rem;
      text-align: center;
      @include touch{
        //padding-right: 2rem;
        //margin: 0.9rem 2rem 0 1.5rem;
        margin: 0.9rem 2rem 0 1.5rem;

      }


      .icon{
        /*border:dashed 1px lightblue;*/
        cursor: pointer;
        margin-left: .2rem;

        @include mobile{
          margin: 0.9rem auto 0 1.5rem;
        }
        color:#ccc;

        &:hover{
          color:$brandPrimary
        }


      }
      .icon{
        font-size: 1.2rem;
        cursor: pointer;

      }
    }
    .menu{
      position: absolute;
      right: 3rem;
      /*padding: 1rem 3rem 1rem 1.5rem;*/
      background: white;
      border: solid 1px #ccc;
      box-shadow: 0 0 3px #ccc;
      font-weight: bold;
      font-size: 0.9rem;
      li{
        text-align: left;
        /*background: lightblue;*/
        border-bottom: solid 1px #eee;
        /*padding: 0.3rem 0;*/
        padding: 0.5rem 3.5rem 0.8rem 1.2rem;
        transition:background-color 150ms ease-in;
        cursor: pointer;


        & a {
          color:#666;
          &:active{
            color: $brandBlue;
          }
        }


        &:hover{
          background: #f9f9f9;
        }


        &.deleteLink{
          color:$brandRed;
          & a{
            color:$brandRed;
          }
        }
        .icon{
          margin-right: 0.3rem;
          &:active{
            color: $brandBlue;
          }
        }


      }
    }

  }

  // FORM ----------------------------------------------------
  .field {
    /*border : #eee dashed  1px;*/
  }

  .input {
    padding: 1.4rem
  }

  .label {
    color: $brandFourth;
  }

  .help {

    //font-style: italic;
    font-size: 0.85rem;
    color: #999;
    &.is-danger{
      color:$brandRed
    }
  }

  // BTN (BUTTON) ----------------------------------------------------
  .call2ActionBtn {

    padding: 1.7rem 2rem;
    font-weight: bold;
    font-size: 1rem;
    /*box-shadow: 0 0 3px;*/

    transition: background-color 150ms ease-in;


  }

  .cronoBtn{
    // une classe commune dans l'application pour harmoniser les boutons (bulma n'ayant pas été bien configuré au début du projet les boutons ont été surchargé jusqu'ici)

    // ⚠️ CETTE CLASS DOIT TOUT DE MÊME ETRE UTILISÉ EN PLUS DE LA CLASSE .button DE BULMA
    padding: 1.3rem 1.4rem ;
    font-weight: bold;
    border-radius: .2rem;
    font-size: .9rem;
    transition: color .25s,  box-shadow 300ms, border .7s;
    //transition: color 300ms;

      // déclinaison de couleurs
      color: #999; // couleur de base

      // 💬 Ajouter la class .invert pour inverser le bouton
      &.invert{
      //color: red;
      background-color: transparent;
      border: solid 1px #ccc;
    }

    &:hover{
      color: $brandThird;
      //box-shadow: 0 0 4px #ccc;
      //border-color: $brandFourth;
      box-shadow: 0 0 3px #ddd;
    }

    &:active{
      color: $brandBlue;
      transition: color .1s;
      border-color: $brandBlue;
    }
  }
  &.darkMode {
    .cronoBtn{
      color: #999;
      //border-color: #4e5455 ;
      border-color: lighten($darkBg,7%) ;

      // déclinaison de couleurs
      //color: #999; // couleur de base
      background-color: $darkBg2;

      &:hover{
        color: $darkContrastTxt;
        border-color: lighten($darkBg,15%) ;
        box-shadow: none;
      }

      &:active{
        color: $darkLightBlue;
        border-color: $darkLightBlue ;
        transition: color .1s;
      }

      // 💬 Ajouter la class .invert pour inverser le bouton
      &.invert{
        //color: red;
        background-color: transparent;
        //border: solid 1px #ccc;
      }
    }
  }



  ////////////////////////////////////////////////////////////////////////////////////////
  // DARK UI ///////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////
  &.darkMode {


    // LAYOUT  ----------------------------------------------------
    .appTitle {

      h3 {color: $darkContrastTxt;}
      .icon {color: $darkLightBlue;}
      .appSubTitle {
        color:#7d7e7e;

      }

    }

    // BLOC  DARK----------------------------------------------------
    .appBloc {
      border-color: lighten($darkBg4,10%) ;
      background: $darkBg !important;
      /*margin: 0 2rem 0 0;*/
      @include mobile {
        //margin: 0;
      }
    }

    // MODALE ----------------------------------------------------
    .modal {
      transition: opacity 300ms ease !important;

      .modal-card-head{background-color:lighten($darkBg3,5%)}
      .modal-card-title{color:$darkContrastTxt;
      }
      .modal-card-body{background-color: $darkBg}
      .modal-card-foot{
         background-color:$darkBg2 !important;

      }
      .cancelLink{
        &:hover{
          background-color: transparent;
        }
        &:focus{
          background-color: transparent;
        }
      }
      .modal-background{
        backdrop-filter: blur(6px);
        background-color: rgba($darkBg, .7);

      }

    }

    // TABLE DARK----------------------------------------------------

    .table {
      $borderColor: $darkTableBorder;
      border-color:$borderColor;

      thead {

        background-color: $darkBg !important;
        tr {
          .icon {
            color: #999;
          }

          th{
            background: $darkTableHeadBg !important;
            border-color: $borderColor;
          }
        }

      }

      tr {
        border-color: $borderColor;
        td{
          border-color: $borderColor;
          background-color: $darkTableTdBg;
        }

      }

      .menuLink{
        .icon{color:#999 !important;}
      }
      .menu{
        background-color: $darkBg2 !important;
        border-color: $darkTableBorder !important;
        box-shadow: 0 0 5px $darkBg3 !important;

        li{
          border-bottom-color: lighten($darkBg,6%) !important;
          a {color:$darkTxt !important;}
          &:hover{
            background-color: darken($darkBg,3%) !important;
          }
          .icon{
            color:$darkLightBlue;
          }
          &:last-child{
            border-color: transparent !important;
          }
          &.deleteLink{
            .icon{
            color:$brandRed !important;
            }
          }

        }

      }
    }

    // FORM ----------------------------------------------------
    .field {
      .input{
        background-color: $darkFieldBg !important;
        border-color: lighten($darkBg3,25%) !important;
        color:$darkContrastTxt !important;
        &::placeholder{
          color:lighten($darkBg3,20%) ;
        }
        &:disabled{opacity: 0.4 ;
          border-color: transparent !important;
        }
      }

    }

      .select{
        select{
          color:$darkContrastTxt;
          border-color: $darkFieldBorder !important;
          background-color: $darkFieldBg !important;

        }
        &.select:not(.is-multiple):not(.is-loading)::after {border-color:$darkLightBlue}
      }
    .label {color: $darkTxt;}

    .help {

      color: #999;
      &.is-danger{color:$brandRed}
    }



  }
}


//// TOOLTIP  --------------------------------------------------
// 🗒 J'ai dû placer les styles en dehors de #appLayoutComp pour qu'ils fonctionnent
  $tooltipBgColor: #666;
  .tippy-popper{
    // 'cronotip' = theme des tooltip du lightmode
    .tippy-tooltip.cronotip-theme {
    background-color: $tooltipBgColor;
    color: white;
      // style de la flèche (https://atomiks.github.io/tippyjs/v6/themes/#styling-the-arrow)
      &[x-placement^=top] .tippy-arrow, {border-top-color: $tooltipBgColor ;}
      &[x-placement^=bottom] .tippy-arrow, {border-top-color: $tooltipBgColor;}
      &[x-placement^=left] .tippy-arrow, {border-top-color: $tooltipBgColor;}
      &[x-placement^=right] .tippy-arrow, {border-top-color: $tooltipBgColor;}
    }

  }

.tippy-popper{
  // 'cronotipdark' = theme des tooltip du dark mode
  $tooltipDarkBgColor: lighten($darkBg4,15%);

  .tippy-tooltip.cronotipdark-theme {
    background-color: $tooltipDarkBgColor;
    color: white;
    // style de la flèche (https://atomiks.github.io/tippyjs/v6/themes/#styling-the-arrow)
    &[x-placement^=top] .tippy-arrow, {border-top-color: $tooltipDarkBgColor ;}
    &[x-placement^=bottom] .tippy-arrow, {border-top-color: $tooltipDarkBgColor;}
    &[x-placement^=left] .tippy-arrow, {border-top-color: $tooltipDarkBgColor;}
    &[x-placement^=right] .tippy-arrow, {border-top-color: $tooltipDarkBgColor;}
  }

}




//// FIN TOOLTIP  --------------------------------------------------


</style>

<style scoped lang="scss">
/*@import '../assets/css/bulmaCustom';*/
@import "../assets/css/bulmaResponsiveDep.scss";
@import "../assets/css/globalVar.scss";

#appLayoutComp{

  // transitions pour le PageLoaderComp
  .fade-enter-active, .fade-leave-active {
    transition: opacity .35s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .column.AppMenu {
    padding: 0;
  }

  .columnAppContent{
    padding: 1.3rem 2rem;
    background: #f4f4f4;
    min-height: 100vh;

    @include mobile {
      padding: 1.1rem 1.5rem;
    }

    .foot {
      margin: 2rem 0;
      border-top: solid 1px #ddd;
      padding: 1.5rem 1rem;
      box-shadow: 0 1px 0 white inset;

      .appName{
        color: #999;
      }
      #pwaVersion{
        margin:0 .3rem;
        background: #ddd;
        color: white;
        padding: 0.2rem 0.3rem; border-radius: 0.2rem;
        font-size: 0.75rem;
      }
      .appInfos {
        color: #ccc;
        font-size: 0.85rem;
        font-weight: bold;
      }
      a{
        margin: 0 0.4rem;
        color: #ccc;
        &:hover{
          text-decoration: underline;
        }

      }
    }
  }

    //////////////////////////////////////
    // DARK UI ///////////////////////////
    &.darkMode {
      .columnAppContent{
        background: $darkBg;
      }

      .foot {
        border-top-color: darken(#666, 25%);
        box-shadow: 0 1px 0 #666 inset !important;

        .appInfos {
          color: #727374
        }

        a {
          color: #a3a6a7
        }

        #pwaVersion {
          color: darken($darkBg, 4%);;
          background-color: lighten($darkBg, 7%);
        }

      }


    }
}
</style>
